import './Cases.scss'
import type { ReactNode } from 'react'
import { Fragment } from 'react'
import { NavLink } from '#src/components/NavLink.js'
import type { InternalLink } from '#src/data/data.js'

interface Props {
  links: InternalLink[]
}

export function Cases(props: Props): ReactNode {
  return (
    <section className="cases__menu">
      <ul className="cases__menu-list">
        {props.links.map((link, index) => (
          <Fragment key={link.url}>
            <NavLink href={link.url} className="cases__menu-link">
              <span>{link.text}</span>
            </NavLink>

            {index < props.links.length - 1 && <li className="cases__menu-slash">/</li>}
          </Fragment>
        ))}
      </ul>
    </section>
  )
}
